// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { Colors } from '@tls/treact-ui';
import styled, { createGlobalStyle } from 'styled-components';

/* Toasts use react-toastify/unstyled — the library ships no CSS, so this
   file owns the entire toast look. The visible chrome of each toast comes
   from <Message/> in @tls/treact-ui; we only style the container, the
   bottom progress bar, and the enter/exit transition. */
export const ToastStyle = createGlobalStyle`
  @media only screen and (max-width: 480px) {
    .Toastify__toast-container {
      width: 100vw;
      padding: 0;
      left: 0;
      margin: 0;
      height: 100vh;
    }
    .Toastify__toast-container--top-left,
    .Toastify__toast-container--top-center,
    .Toastify__toast-container--top-right {
      top: 0;
      transform: translateX(0);
    }
    .Toastify__toast-container--bottom-left,
    .Toastify__toast-container--bottom-center,
    .Toastify__toast-container--bottom-right {
      bottom: 0;
      transform: translateX(0);
    }
    .Toastify__toast-container--rtl {
      right: 0;
      left: initial;
    }
  }

  .Toastify__toast {
    margin-bottom: 1rem;
  }

  .Toastify__progress-bar--wrp {
    position: relative;
    height: 0.5rem;
    width: 100%;
    /* Pull the bar up so it sits inside the bottom border of <Message/>
       instead of below it. */
    transform: translateY(-1.3rem);
  }
  .Toastify__progress-bar {
    position: absolute;
    /* Inset from the left so the bar clears <Message/>'s icon column and
       aligns with the headline/body content area. */
    left: 1.25rem;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgb(${Colors.trblue4.rgb});
    transform-origin: left;
    z-index: 9999;
  }
  .Toastify__progress-bar--animated {
    animation: sw91-track-progress linear 1 forwards;
  }
  @keyframes sw91-track-progress {
    0% { transform: scaleX(1); }
    to  { transform: scaleX(0); }
  }

  @keyframes sw91-toast-fade-in {
    0% { opacity: 0; }
    to { opacity: 1; }
  }
  @keyframes sw91-toast-fade-out {
    0% { opacity: 1; }
    to { opacity: 0; }
  }
  .sw91-toast-fade-in {
    animation-name: sw91-toast-fade-in;
    animation-duration: 0.7s;
    animation-fill-mode: both;
  }
  .sw91-toast-fade-out {
    animation-name: sw91-toast-fade-out;
    animation-duration: 0.7s;
    animation-fill-mode: both;
  }
`;

export const StatusBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  overflow: hidden;
`;
